/**
 * 
 */
export interface GoodsInfo {
    id?: string,
    weight: number,
    name: string,
    count: number,
    packageType?: string,
    //荷物の制約事項
    handlingInstructions?: string[];
}

export function getTotalWeight(items: GoodsInfo[]): number {
    let result = 0;
    items.map((v, i) => result += (v.weight * v.count));
    return result;
}